import { render, staticRenderFns } from "./PunoC.vue?vue&type=template&id=0e33c020&"
import script from "./PunoC.vue?vue&type=script&lang=js&"
export * from "./PunoC.vue?vue&type=script&lang=js&"
import style0 from "./PunoC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports